import { render, staticRenderFns } from "./TimeZoneClock.vue?vue&type=template&id=006c87d2"
import script from "./TimeZoneClock.vue?vue&type=script&lang=js"
export * from "./TimeZoneClock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports